import { observer } from 'mobx-react-lite'
import { Avatar, IconButton, type ITableConfig, Tooltip, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { type ReviewContactRow } from 'entities/Review'
import { useReviewAnalyticsContext } from 'pages/reviews/context'
import styles from './styles.module.scss'

type IReviewContactNameCellProps = {
  row: ReviewContactRow
  config?: ITableConfig
}

export const ReviewContactNameCell = observer(({ row, config }: IReviewContactNameCellProps) => {
  const { onOpenContactsDetails } = useReviewAnalyticsContext()
  const { contactId } = row

  return (
    <div className={styles.contactColumn}>
      <div className={styles.contactColumnName}>
        <Avatar info={row.avatarInfo} size={24} />
        {row.fullName ? (
          <Typography
            variant='body-md-regular'
            ariaLabel='ReviewContactName'
            ellipsis
            tooltipProps={{
              label: row.fullName,
              breakWord: true,
            }}
          >
            {row.fullName}
          </Typography>
        ) : (
          <EmptyCell />
        )}
      </div>

      {contactId !== null && !row.isDeleted && (
        <Tooltip label='Conversation' placement='top'>
          <IconButton
            icon='conversation'
            variant='icon'
            color='tertiary'
            transparentInactive
            className={config?.hidden}
            ariaLabel='open_conversation'
            disabled={onOpenContactsDetails.disabled}
            onClick={(event) => {
              event.stopPropagation()
              onOpenContactsDetails.open({ contactId })
            }}
          />
        </Tooltip>
      )}
    </div>
  )
})
